













import { Vue, Component, Prop } from 'vue-property-decorator'
import { User } from '../store'
import { BIconDoorOpen, BIconPerson } from 'bootstrap-vue'
import { Messages } from '@/assets/langs/langs'

@Component({
  components: {
    BIconDoorOpen,
    BIconPerson
  }
})
export default class userInfos extends Vue {
@Prop() readonly user: User | undefined

get messages () {
  return <Messages['components']['UserInfos']>this.$store.getters.messages.components.UserInfos
}
get userLogin (): string {
  return this.user!.login
}

get userDisplay (): string {
  const applicationDescription = this.user?.application_description
  if (applicationDescription) {
    return `${this.userLogin} - ${applicationDescription}`
  }
  return this.userLogin
}

logout (): void {
  this.$store.dispatch('logout')
  const loginRoute = this.$router.resolve({name: 'login'}).route.path
  if (this.$router.currentRoute.path !== loginRoute)
    this.$router.push(loginRoute)
}
}
